import {useState, Fragment} from 'react'
import Uppy from '@uppy/core'
import '../@core/scss/react/libs/file-uploader/file-uploader.scss';
import {DragDrop} from '@uppy/react'
import {Card, CardHeader, CardTitle, CardBody, Col, Row} from 'reactstrap'
import XHRUpload from "@uppy/xhr-upload";

import axios from "axios";
import {getUserData} from "../auth/utils";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal)

const FileUploaderMulti = (props) => {
    let options = {
        width: "50%",
        autoProceed: true,
        allowMultipleUploads: false,
        restrictions: {
            maxFileSize: 5 * 1024 * 1024,
            maxNumberOfFiles: 1,
            allowedFileTypes: ['.jpg', '.jpeg', 'gif', '.png', ".pdf", ".doc"],
        },
    };
    if (props.imagesOnly) {
        options.restrictions.allowedFileTypes = [".jpg", ".png"];
    }

    if (props.singleFile) {
        options.allowMultipleUploadBatches = false;
    }
    const uppy = new Uppy(options).use(XHRUpload, {
        endpoint: `${process.env.REACT_APP_MAIN_URL}/upload`,
        fieldName: "file"
    }).on('upload-success', (file, response) => {
        let newFiles = [...props.fileDetails];
        if (props.oneFileOnly) {
            newFiles = [];
        }
        newFiles.push(file)
        newFiles = newFiles.map((newFile) => {
            if (file.data && newFile.data && (file.data.name === newFile.data.name)) {
                newFile.uploadUrl = response.uploadURL;
                newFile.url = response.uploadURL;
            }
            return newFile;
        });
        props.setFilesDetails([...newFiles]);
        if (props.updateDocument) {
            axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/add-document?`, {
                user: getUserData().userData._id,
                document: response.uploadURL
            }).then((result) => {
                MySwal.fire({
                    icon: 'success',
                    title: 'Uspješno',
                    text: 'Dodan dokument.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                }).then(() => {
                    let data = getUserData();
                    data.userData.files.push(response.uploadURL)
                    localStorage.setItem('userData', JSON.stringify(data))
                    window.location.reload();
                });
            }).catch((e) => {
                window.alert("Nesto je poslo po krivu. Molim probajte ponovno.");
            });
        }
    })

    return (
        <Card className="text-center d-inline-block" style={{minHeight: "30vh"}}>
            {props.title &&
            <CardHeader>
                <CardTitle>{props.title}</CardTitle>
            </CardHeader>
            }
            <CardBody className="text-center">
                <Row>
                   
                    <Col md={12} className="justify-content-center my-auto align-content-center">
                        <DragDrop
                            note={props.title2}
                            background={"white"}
                            height={props.small ? "10%" : "200px"}
                            width={props.small ? "100%" : "100%"}
                            locale={{
                                strings: {
                                   dropHereOr: "Povucite datoteke ovdje ili %{browse}",
                                   browse: 'pretražite na računalu' 
                                }
                            }}
                            uppy={uppy}/>
                    </Col>
                   
                </Row>
            </CardBody>

        </Card>
    )
}

export default FileUploaderMulti
